import React from 'react'

export default function ClickEvent() {
    return (
        <section id="click-event" className="mt-5">
            <h3 className="text-xl font-semibold mb-3">⚡ Click Event Handler</h3>
            <p>
                The <code>.click-event</code> class is used to toggle interface sections such as the <strong> menu</strong>, <strong>cart</strong> or <strong>search </strong> panel by
                adding and removing state classes on the <code>&lt;body&gt;</code> element.
            </p>

            <h5 className="text-lg font-semibold mt-4">🧱 HTML Example</h5>
            <pre className="overflow-auto">
                <code>
                &lt;button className="btn click-event" data-type="menu"&gt;
                &lt;i className="fa fa-bars text-xl"&gt;&lt;/i&gt;
                &lt;/button&gt;
                </code>
            </pre>

            <h5 className="text-lg font-semibold mt-4">🧩 JavaScript Logic</h5>
            <pre className="overflow-auto">
                <code>
                {`$(document).on('click', '.click-event', function (e) {
  const body = $('body');
  const type = e.target.dataset.type;

  if (type) {
    body.addClass('no-scroll');
    body.addClass(\`open-\${type}\`);
  } else {
    window.location.hash = ';
    body.removeClass('no-scroll open-cart open-search open-menu');
  }
});`}
</code>
            </pre>

            <h5 className="text-lg font-semibold mt-4">🧠 How It Works</h5>
            <ul className="list-disc pl-6">
                <li>When a button with <code>.click-event</code> is clicked, it checks for <code>data-type</code> (like <code>menu</code>).</li>
                <li>If present, the script adds <code>no-scroll</code> and <code>open-[type]</code> classes to the <code>&lt;body&gt;</code>.</li>
                <li>These classes control the visibility of UI panels through TailwindCSS or custom CSS.</li>
                <li>If no <code>data-type</code> is provided, all open classes are removed and scrolling is re-enabled.</li>
            </ul>


            <p className="mt-3 text-gray-700">
                Use <code>data-type="menu"</code>, <code>data-type="cart"</code>, or <code>data-type="search"</code>
                depending on which panel should open.
            </p>
        </section>

    )
}